module.exports = __webpack_public_path__ + "img/newlogo.21313294.png";